import { Outlet } from 'react-router-dom';
import WhatsAppButton from './WhatsAppButton';

const RootLayout = () => {
  return (
    <>
      <Outlet />
      <WhatsAppButton />
    </>
  );
};

export default RootLayout;


